<template>
  <div class="banner-container d-flex flex-column justify-content-center position-relative">
    <div class="d-none d-lg-block image-background position-absolute w-100 h-100"></div>
    <b-row class="mb-3 title-row">
      <b-col cols="12" class="title text-center">
        <div class="d-flex flex-column align-items-center justify-content-center">
          <h2 class="mb-3">{{ $t(`${plansPage}.${getExperience}.subscribeBanner.text`) }}</h2>
          <Button color="green" @click="click">
            {{ $t(`${plansPage}.${getExperience}.subscribeBanner.btnText`) }}
          </Button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Button from 'UI/Button';

export default {
  components: {
    Button
  },
  props: {
    lifetime: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    ...mapGetters('experience', ['getExperience']),
    plansPage() {
      return this.lifetime ? 'lifetimePlans' : 'plans';
    }
  },
  methods: {
    click() {
      const options = {
        offset: -100
      };
      this.$scrollTo('.purchase-flow-container', 500, options);
      this.$ga.event('All Plans', 'Click Button Subscribe Bottom Plans', this.$route.fullPath);
    }
  }
};
</script>

<style lang="scss" scoped>
.banner-container {
  height: 400px;
  align-items: center;
  .title {
    font-size: 40px;
    font-weight: 500;
  }
  .image-background {
    background-position: left;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url('https://cdn.vexels.com/img/plans-subscribe-banner.png');
  }
  .title-row {
    margin-left: 0;
    margin-right: 0;
  }
}
</style>
